var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAnexo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4176 0.951172H4.61231C2.06296 0.951172 0 2.85269 0 5.19388C0 7.53506 2.06296 9.43658 4.61231 9.43658H12.5791V8.27948H4.61231C2.75902 8.27952 1.25791 6.89869 1.25791 5.19388C1.25791 3.48906 2.75902 2.10828 4.61231 2.10828H13.4176C14.5749 2.10828 15.5141 2.97224 15.5141 4.03677C15.5141 5.10131 14.5749 5.96527 13.4176 5.96527H6.28953C5.82831 5.96527 5.45094 5.62201 5.45094 5.19388C5.45094 4.76575 5.82831 4.42249 6.28953 4.42249H12.5791V3.26538H6.28953C5.13225 3.26538 4.19303 4.12934 4.19303 5.19388C4.19303 6.25841 5.13225 7.12241 6.28953 7.12241H13.4176C15.271 7.12241 16.772 5.74159 16.772 4.03681C16.772 2.33203 15.271 0.951172 13.4176 0.951172Z",
    fill: "#364863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnexo);
export default __webpack_public_path__ + "static/media/icon-anexo.30632bdf69660ab9cfa69602c8465cb4.svg";
export { ForwardRef as ReactComponent };